import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Unstable_Grid2";
import { Button } from "@mui/material";
import { Breadcrumb } from "../../../components";
import { CardHeader } from "../../../components/cards";
import { Box } from "../../../components/elements";
import PageLayout from "../../../layouts/PageLayout";
import { DataGrid } from "@mui/x-data-grid";
import { Modal, ModalClose, Sheet, Typography } from "@mui/joy";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";

export default function FilterList() {
  const token = localStorage.getItem("token");
  const navigate = useNavigate();

  const [filters, setFilters] = useState([]);
  const [callApi, setCallApi] = useState(false);
  const [warning, setWarning] = useState({ text: "", type: "" });
  const [selectedId, setSelectedId] = useState(null);
  const [openWarning, setOpenWarning] = useState(false);

  const fetchFilters = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BASE_URL}common/filters`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setFilters(res.data);
    } catch {
      alert("Session expired");
      localStorage.clear();
      navigate("/login");
    }
  };

  const deleteFilter = async (id) => {
    try {
      await axios.delete(
        `${process.env.REACT_APP_BASE_URL}common/filters/${id}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setCallApi((prev) => !prev);
    } catch {
      alert("Failed to delete filter");
    }
  };

  useEffect(() => {
    fetchFilters();
  }, [callApi]);

  const columns = [
    { field: "s_no", headerName: "S.no", width: 80 },
    { field: "quadrant", headerName: "Quadrant", flex: 1 },
    { field: "index", headerName: "Index", width: 100 },
    { field: "name", headerName: "Name", flex: 1 },
    {
      field: "actions",
      headerName: "Actions",
      width: 180,
      sortable: false,
      renderCell: (params) => (
        <div style={{ display: "flex", gap: "0.5rem" }}>
          {/* Edit */}
          <Button
            size="small"
            variant="contained"
            color="primary"
            onClick={() => navigate(`/edit-filter/${params.row.id}`)}
          >
            <i className="fas fa-edit" />
          </Button>

          {/* Delete */}
          <Button
            size="small"
            variant="contained"
            color="error"
            onClick={() => {
              setSelectedId(params.row.id);
              setWarning({ text: "Delete this filter?", type: "delete" });
              setOpenWarning(true);
            }}
          >
            <i className="fas fa-trash" />
          </Button>
        </div>
      ),
    },
  ];

  const rows = filters.map((f, idx) => ({
    id: f._id,
    s_no: idx + 1,
    quadrant: f.quadrant?.name || "—",
    index: f.index,
    name: f.name,
  }));

  return (
    <PageLayout>
      <Grid container spacing={3}>
        <Grid
          size={12}
          sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
        >
          <Breadcrumb title="Filter List" />
          <Link to="/add-filter">
            <Button variant="contained" color="primary">Add Filter</Button>
          </Link>
        </Grid>

        <Grid size={12}>
          <Box className="mc-card">
            <CardHeader title="Filter List" />
            <div style={{ height: 600, width: "100%", marginTop: "1rem" }}>
              <DataGrid
                rows={rows}
                columns={columns}
                pageSize={10}
                rowsPerPageOptions={[10, 25, 50]}
                disableSelectionOnClick
              />
            </div>
          </Box>
        </Grid>

        {/* Delete Confirmation */}
        <Modal
          open={openWarning}
          onClose={() => setOpenWarning(false)}
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
          }}
        >
          <Sheet
            variant="outlined"
            sx={{
              width: "30%",
              p: 3,
              borderRadius: "md",
              boxShadow: "lg",
              bgcolor: "#fff",
            }}
          >
            <ModalClose sx={{ top: 8, right: 8 }} />
            <Typography fontSize="1.25em" mb={3}>
              {warning.text}
            </Typography>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "2rem",
              }}
            >
              <Button
                variant="contained"
                color="success"
                style={{ width: "8rem" }}
                onClick={() => {
                  deleteFilter(selectedId);
                  setOpenWarning(false);
                }}
              >
                Yes
              </Button>
              <Button
                variant="contained"
                color="error"
                style={{ width: "8rem" }}
                onClick={() => setOpenWarning(false)}
              >
                No
              </Button>
            </div>
          </Sheet>
        </Modal>
      </Grid>
    </PageLayout>
  );
}
